/**
 * Shared syntax highlighting styles for ChordPro content.
 *
 * Used by both ChordProEditor (editable) and ChordProHighlight (read-only display).
 */
import { themeColors } from "@bandwith/styles";
import { HighlightStyle } from "@codemirror/language";
import { tags as t } from "@lezer/highlight";

export const chordProHighlighting = HighlightStyle.define([
  // Comments - muted gray italic
  { tag: t.lineComment, color: themeColors.textMuted, fontStyle: "italic" },

  // Directives - keyword style
  { tag: t.keyword, color: themeColors.copper, fontWeight: "500" },

  // Directive values and strings
  { tag: t.string, color: themeColors.greenMuted },

  // Chords - amber, the main musical element
  { tag: t.tagName, color: themeColors.amber, fontWeight: "500" },

  // Annotations - copper/orange
  { tag: t.annotation, color: themeColors.copper, fontStyle: "italic" },

  // Variables
  { tag: t.variableName, color: themeColors.textSecondary },

  // Operators
  { tag: t.operator, color: themeColors.textMuted },

  // Special strings (ternaries)
  {
    tag: t.special(t.string),
    color: themeColors.greenMuted,
    fontStyle: "italic",
  },

  // Punctuation
  { tag: t.brace, color: themeColors.textMuted },
  { tag: t.squareBracket, color: themeColors.textMuted },
  { tag: t.punctuation, color: themeColors.textMuted },
  { tag: t.separator, color: themeColors.textMuted },

  // Escape sequences
  { tag: t.escape, color: themeColors.copper },

  // Content/lyrics - default text color
  { tag: t.content, color: themeColors.textSecondary },
]);
